import { Button, Icon, Input, Switch, Table } from "antd"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import { MainActions, AuthActions } from "redux-store/models"
import EditListinoForm from "./EditListinoForm"
import AddListinoModalForm from "./AddListinoModal"

const Listino = (props) => {
  const {
    getListinoList,
    listinoList,
    getSingleListino,
    updateListino,
    createListino,
  } = props
  const [searchQuery, setSearchQuery] = useState("")
  const [addListinoVisible, setAddListinoVisible] = useState(false)
  const [editListinoVisible, setEditListinoVisible] = useState(false)
  const [selectedListino, setSelectedListino] = useState({})

  const filteredData = listinoList.filter((listino) =>
    listino.name.toLowerCase().includes(searchQuery.toLowerCase())
  )

  useEffect(() => {
    getListinoList()
  }, [])

  console.log(listinoList)

  const columns = [
    {
      title: "Listino ID",
      dataIndex: "id",
      ellipsis: true,
      width: "6%",
    },
    {
      title: "Nome Listino",
      dataIndex: "name",
      ellipsis: true,
      width: "10%",
    },
    {
      title: "Description",
      dataIndex: "description",
      ellipsis: true,
      width: "15%",
    },
    {
      title: "Skins",
      dataIndex: "skins",
      ellipsis: true,
      width: "15%",
      render: () => "MrPay",
    },
    {
      title: "Servizi totali",
      dataIndex: "services",
      ellipsis: true,
      width: "8%",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => {
        return (
          <Switch
            style={{ width: 30 }}
            size="small"
            checked={record.status === 1}
            onChange={() => {
              console.log(record.status)
              updateListino(
                record.name,
                record.status === 1 ? 0 : 1,
                null,
                record.id
              )
            }}
          />
        )
      },
      width: "8%",
      align: "center",
    },

    {
      title: "Impostazioni",
      render: (text, record) => (
        <Button
          icon="setting"
          onClick={() => {
            getSingleListino(record.id)
            setEditListinoVisible(true)
            setSelectedListino(record)
          }}
        ></Button>
      ),
      ellipsis: true,
      width: "8%",
      align: "center",
    },
  ]

  return (
    <>
      <AddListinoModalForm
        isVisible={addListinoVisible}
        onClose={() => setAddListinoVisible(false)}
        createListino={createListino}
        listinoList={listinoList}
      />
      <EditListinoForm
        visible={editListinoVisible}
        selectedListino={selectedListino}
        onClose={() => setEditListinoVisible(false)}
      />
      <div className="Container Annunci AllServices providers-admin">
        <div className="container-fluid overview">
          <div className="panels-container">
            <div className="provider-header">
              <div className="title">
                <Icon type="bank" /> Listino
              </div>
              <div className="filters">
                <Button
                  type="primary"
                  icon="plus"
                  onClick={() => setAddListinoVisible(true)}
                >
                  Crea Nuovo Listino
                </Button>
                <Input
                  placeholder="Cerca"
                  suffix={<Icon type="search" />}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
            <div className="providers-table">
              <Table
                dataSource={filteredData}
                columns={columns}
                pagination={false}
                className="table-striped-rows"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  listinoList: state.main.listinoList,
})

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  withRouter(Listino)
)
